var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45px",
    height: "45px",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,83.137255%,100%)",
      fillOpacity: 1
    },
    d: "M 52.589844 6.25 L 118.75 6.25 C 125.652344 6.25 131.25 11.847656 131.25 18.75 L 131.25 131.25 C 131.25 138.152344 125.652344 143.75 118.75 143.75 L 31.25 143.75 C 24.347656 143.75 18.75 138.152344 18.75 131.25 L 18.75 40.089844 C 18.75 38.429688 19.410156 36.839844 20.582031 35.667969 L 48.167969 8.082031 C 49.339844 6.910156 50.929688 6.25 52.589844 6.25 Z M 52.589844 6.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(64.313725%,69.411765%,100%)",
      fillOpacity: 1
    },
    d: "M 34.375 43.75 L 59.375 43.75 C 64.550781 43.75 68.75 47.949219 68.75 53.125 C 68.75 58.300781 64.550781 62.5 59.375 62.5 L 34.375 62.5 C 29.199219 62.5 25 58.300781 25 53.125 C 25 47.949219 29.199219 43.75 34.375 43.75 Z M 34.375 43.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.45098%,89.803922%,100%)",
      fillOpacity: 1
    },
    d: "M 62.5 15.089844 L 62.5 41.160156 C 62.5 46.042969 58.542969 50 53.660156 50 L 27.589844 50 C 22.707031 50 18.75 46.042969 18.75 41.160156 C 18.75 38.816406 19.679688 36.570312 21.339844 34.910156 L 47.410156 8.839844 C 49.070312 7.179688 51.316406 6.25 53.660156 6.25 C 58.542969 6.25 62.5 10.207031 62.5 15.089844 Z M 62.5 15.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,94.901961%,100%)",
      fillOpacity: 1
    },
    d: "M 26.292969 36.207031 L 48.707031 13.792969 C 50.429688 12.070312 53.230469 12.070312 54.957031 13.792969 C 56.679688 15.519531 56.679688 18.320312 54.957031 20.042969 L 32.542969 42.457031 C 30.820312 44.179688 28.019531 44.179688 26.292969 42.457031 C 24.570312 40.730469 24.570312 37.929688 26.292969 36.207031 Z M 26.292969 36.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,36.862745%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 75 25 L 106.25 25 C 109.703125 25 112.5 27.796875 112.5 31.25 L 112.5 68.75 C 112.5 72.203125 109.703125 75 106.25 75 L 75 75 C 71.546875 75 68.75 72.203125 68.75 68.75 L 68.75 31.25 C 68.75 27.796875 71.546875 25 75 25 Z M 75 25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.627451%,22.352941%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 50 125 L 43.75 125 C 40.300781 124.996094 37.503906 122.199219 37.503906 118.75 C 37.503906 115.300781 40.300781 112.503906 43.75 112.5 L 50 112.5 C 53.449219 112.503906 56.246094 115.300781 56.246094 118.75 C 56.246094 122.199219 53.449219 124.996094 50 125 Z M 50 125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.627451%,22.352941%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 106.25 125 L 75 125 C 71.550781 124.996094 68.753906 122.199219 68.753906 118.75 C 68.753906 115.300781 71.550781 112.503906 75 112.5 L 106.25 112.5 C 109.699219 112.503906 112.496094 115.300781 112.496094 118.75 C 112.496094 122.199219 109.699219 124.996094 106.25 125 Z M 106.25 125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.627451%,22.352941%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 106.25 100 L 43.75 100 C 40.296875 100 37.5 97.203125 37.5 93.75 C 37.5 90.296875 40.296875 87.5 43.75 87.5 L 106.25 87.5 C 109.703125 87.5 112.5 90.296875 112.5 93.75 C 112.5 97.203125 109.703125 100 106.25 100 Z M 106.25 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,84.313725%,0%)",
      fillOpacity: 1
    },
    d: "M 100 40.625 C 100 45.800781 95.800781 50 90.625 50 C 85.449219 50 81.25 45.800781 81.25 40.625 C 81.25 35.449219 85.449219 31.25 90.625 31.25 C 95.800781 31.25 100 35.449219 100 40.625 Z M 100 40.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,84.313725%,0%)",
      fillOpacity: 1
    },
    d: "M 100 56.25 L 81.25 56.25 C 77.800781 56.253906 75.003906 59.050781 75.003906 62.5 C 75.003906 65.949219 77.800781 68.746094 81.25 68.75 L 100 68.75 C 103.453125 68.75 106.25 65.953125 106.25 62.5 C 106.25 59.046875 103.453125 56.25 100 56.25 Z M 100 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(64.313725%,69.411765%,100%)",
      fillOpacity: 1
    },
    d: "M 78.125 75 L 103.125 75 C 104.851562 75 106.25 76.398438 106.25 78.125 C 106.25 79.851562 104.851562 81.25 103.125 81.25 L 78.125 81.25 C 76.398438 81.25 75 79.851562 75 78.125 C 75 76.398438 76.398438 75 78.125 75 Z M 78.125 75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume-icon.a98538e403ed328e9dd6cb745a34afe6.svg";
export { ForwardRef as ReactComponent };